import * as yup from "yup";
import i18n from "../../../i18n";

const requiredMessage = () => i18n.t("validation.required", {ns: "common"});
const min5LengthsMessage = () => i18n.t("validation.minLengths", {ns: "common", min: 5});
const max500LengthsMessage = () => i18n.t("validation.maxLength", {ns: "common", max: 500});
const min0Message = () => i18n.t("validation.minNumber", {ns: "common", min: 0});
const max9999Message = () => i18n.t("validation.maxNumber", {ns: "common", max: 9999});

export const addSubCompanyValidation = yup.object().shape({
    name: yup.string().required(requiredMessage),
    address: yup
        .string()
        .min(5, min5LengthsMessage)
        .max(500, max500LengthsMessage)
        .required(requiredMessage),
    location: yup.object().shape({
        longitude: yup.number().required(requiredMessage),
        latitude: yup.number().required(requiredMessage)
    }),
    authorizedEmail: yup.string().required(requiredMessage),
    authorizedPerson: yup.string().required(requiredMessage),
    authorizedPhone: yup.string().required(requiredMessage),
    name: yup.string().required(requiredMessage),
    uniqueKey: yup.string(),
    subCompanyCode: yup
        .number()
        .min(0, min0Message)
        .max(9999, max9999Message)
        .required(requiredMessage)
});
